var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BAlert',{attrs:{"variant":_vm.variant,"show":""}},[_c('div',{staticClass:"d-flex justify-content-center"},[(!_vm.message)?_c('div',{staticClass:"spinner-grow"}):_vm._e()]),(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }